import React from 'react'
import { FormSelect } from 'atoms/Inputs'
import { Months, Years, Status } from 'fixtures/timeValues'
import { withTheme } from 'styled-components'
import { Container, StyledLabel } from './styles'

const MonthYearInput = ({ theme, fn, val }) => {
  const inputConfig = {
    border: theme.mocaGrey,
    rad: '6px',
    width: '100%',
    yxPadding: '9px 12px',
    height: '34px',
  }

  return (
    <Container>
      <StyledLabel>Month: </StyledLabel>
      <FormSelect
        placeholder={`Select month`}
        onChangeVal={e => fn(e.target.value, 'month')}
        options={Months}
        value={val.month}
        valField={'value'}
        dispField={'label'}
        arrowSize={'12%'}
        mr={window.innerWidth <= 960 ? '.5rem' : '1.5rem'}
        {...inputConfig}
      />

      <StyledLabel>Year: </StyledLabel>
      <FormSelect
        placeholder={`Select year`}
        onChangeVal={e => fn(e.target.value, 'year')}
        options={Years}
        value={val.year}
        valField={'year'}
        dispField={'year'}
        arrowSize={'12%'}
        mr={window.innerWidth <= 960 ? '.5rem' : '1.5rem'}
        {...inputConfig}
      />

      <StyledLabel>Status: </StyledLabel>
      <FormSelect
        placeholder={`Select status`}
        onChangeVal={e => fn(e.target.value, 'status')}
        options={Status}
        value={val.status}
        valField={'value'}
        dispField={'label'}
        arrowSize={'12%'}
        {...inputConfig}
      />
    </Container>
  )
}

export default withTheme(MonthYearInput)
